export default __webpack_public_path__ + "9aadb10136e9d23fcdd6555ee6bb922b.ico";